<template>
    <div class="mineTest-foot__orderNum flex flex--middle" v-show="propOrderNum != ''">
            <span class="orderId flex__item">
                    <div class="wrapper"><span class="text">订单编号：</span>{{propOrderNum}}</div></span>
        <button ref="copyBtn" class="copyTip" id="copyTip" 
                :data-clipboard-text="propOrderNum+''">复制
        </button>
    </div>
</template>

<script>
    import Clipboard from 'clipboard';

    export default {
        name: 'mineTestFooter',
        props: {
            propOrderNum: {
                required: true,
                type: [String, Number],
                default: ''
            },
        },
        mounted(){
            const that = this;
            that.initCopy()
        },
        methods: {
            initCopy() {
                const that = this;
                that.$nextTick(() => {
                    let clipboard = new Clipboard(that.$refs.copyBtn);
                    clipboard.on('success', function (e) {
                        e.trigger.innerText = '已复制';
                        e.clearSelection();
                        setTimeout(() => {
                            e.trigger.innerText = '复制';
                        }, 1000)
                    });
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../scss/function';

    .mineTest-foot {
        &__orderNum {
            // padding-left: topx(7rem);
            // padding-right: topx(7rem);
            // height: topx(84rem);
            overflow: hidden;
            font-size: 12px;
            color: #999;
            float: left;
            position: absolute;
            bottom: topx(0rem);
            .text {
                color: #999;
                white-space: nowrap;
                width: 5.2em;
            }
            .orderId {
                color: #333;
                // height: topx(84rem);
                // line-height: topx(84rem);
                white-space: nowrap;
                overflow: hidden;
                .wrapper {
                    width: 100%;
                    // height: topx(94rem);
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            .copyTip {
                width: 3.5em;
                // height: topx(46rem);
                margin-left: topx(10rem);
                padding: topx(2rem) topx(4rem);
                font-size: 10px;
                color: #999;
                background: #FFFFFF;
                border: 1px solid #999999;
                border-radius: topx(8rem);
                white-space: nowrap;
            }
        }
        &__actions {
            height: topx(94rem);
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/show/mine/mineTestOrderNum.vue